<template>
  <div class="tutorial-final">
    <img
      :src="content.image"
      alt="arrow"
    >
    <h1>{{ content.title }}</h1>
    <div class="description-container">
      <p>{{ content.description }}</p>

      <p class="footer">
        {{ content.footerMessage }}
      </p>

      <div class="cta">
        <tutorial-button
          :action="action"
          :content="content.cta"
        />
        <p>ou</p>
        <p
          class="link"
          @click="action('link', index)"
        >
          {{ content.link[index].label }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './tutorialMixin'

export default {
  name: 'TutorialFinal',
  mixins: [mixin],
  data: () => ({
    index: 0
  })
}
</script>

<style lang="scss">
.tutorial-final {
  z-index: 9004;
  position: fixed;
  top: 20%;
  left: 15%;
  width: 57%;

  h1 {
    padding-top: 30px;
    padding-bottom: 10px;
  }

  .description-container {
    width: 100%;

    .footer {
      margin-top: 20px;
    }

    .cta {
      display: flex;
      align-items: baseline;

      p {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: normal;
        line-height: 26px;
        font-size: 14px;
        color: #E5E5E5;
        padding-right: 20px;
      }

      .link {
        text-decoration-line: underline;
        cursor: pointer;
      }
    }
  }
}
</style>
